module.exports = __webpack_public_path__ + "img/1439913300.435aa5a6.jpg";